import React from "react";
import { RadioTable } from "@components";
import { customersModule, reconciliationv2Module } from "@auth/modules";
import { useMerchant } from "@auth";
import { useRequestTemplates } from "@flags";

const accessPermissionOptions = [
  { option: "none", display: "No access" },
  { option: "view", display: "View only" },
  { option: "full", display: "Full access" },
];

const AccessPermissionsRadioTable = ({
  radioClicked,
  selectedAccessPermissions,
}) => {
  const { hasModule } = useMerchant();
  const requestTemplatesEnabled = useRequestTemplates();

  const accessPermissionSubjects = [
    hasModule(customersModule) && {
      id: "customerLevel",
      title: "Manage trade accounts",
      tagline: "User can manage and request payment from trade accounts.",
      options: ["none", "view", "full"],
    },
    {
      id: "paymentLevel",
      title: "Manage transactions",
      tagline: "User can view, receive payments, and issue refunds.",
      options: ["none", "view", "full"],
    },
    requestTemplatesEnabled
      ? {
          id: "paymentRequestTemplateLevel",
          title: "Manage payment request templates",
          tagline: "User can edit payment request templates.",
          options: ["view", "full"],
        }
      : {
          id: "messageTemplateLevel",
          title: "Manage message templates",
          tagline: "User can edit template email and SMS messages.",
          options: ["none", "view", "full"],
        },
    {
      id: "payoutLevel",
      title: "Manage payouts",
      tagline: "User can view and manage payouts.",
      options: ["none", "view"],
    },
    hasModule(reconciliationv2Module) && {
      id: "ledgerPaymentLevel",
      title: "Manage reconciliation",
      tagline:
        "User can review and manage payment reconciliation against the ERP.",
      options: ["none", "view", "full"],
    },
  ].filter(Boolean);

  const getRadioTableData = () => {
    return accessPermissionSubjects.map((perm) => ({
      ...perm,
      currentOption: selectedAccessPermissions[perm.id] || "none",
    }));
  };

  return (
    <RadioTable
      options={accessPermissionOptions}
      data={getRadioTableData}
      radioClicked={radioClicked}
    />
  );
};

export default AccessPermissionsRadioTable;
